<div class="modal fade" id="modal-nova-notificacao" tabindex="-1" aria-labelledby="modal-nova-notificacao" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modal-nova-notificacao-label">
                    <i class='bx bx-bell me-2'></i>
                    Nova Notificação
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" *ngIf="notificacao">
                <div class="dropdown-body">
                    <div class="dropdown-item d-flex align-items-center">
                        <div class="icon me-3">
                            <!-- Ícone baseado no tipo da notificação -->
                            <i class='bx-message-rounded-dots'  style="font-size: 1.5rem;"></i>
                        </div>
                        <div class="content flex-grow-1">
                            <h6 class="mb-1">{{ notificacao.titulo }}</h6>
                            <p class="mb-2">{{ notificacao.mensagem }}</p>
                            <small class="text-muted" *ngIf="notificacao.dataCriacao">
                                {{ notificacao.dataCriacao | date:'dd/MM/yyyy HH:mm:ss' }}
                            </small>

                            <!-- Dados adicionais se houver -->
                            <div class="mt-2" *ngIf="notificacao.dados">
                                <small class="text-muted">
                                    <strong>Detalhes:</strong>
                                </small>
                                <pre class="text-muted small mt-1">{{ notificacao.dados | json }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    <i class='bx bx-x me-1'></i>
                    Fechar
                </button>
                <a *ngIf="notificacao?.dados?.chamadoId"
                   [href]="'/pedido/' + notificacao.dados.chamadoId"
                   class="btn btn-primary"
                   data-bs-dismiss="modal">
                    <i class='bx bx-show me-1'></i>
                    Ver Pedido
                </a>
            </div>
        </div>
    </div>
</div>

<nav class="navbar top-navbar navbar-expand header-moderno">
    <div class="collapse navbar-collapse" id="navbarSupportContent">
        <div class="responsive-burger-menu d-block d-lg-none">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
        <!--<form class="nav-search-form d-none ms-auto d-md-block">
            <label><i class='bx bx-search'></i></label>
            <input type="text" class="form-control" placeholder="Search here...">
        </form>-->
        <ul class="navbar-nav right-nav align-items-center ms-auto">
            <!--<li class="nav-item message-box dropdown">
                <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <div class="message-btn">
                        <i class='bx bx-envelope'></i>
                        <span class="badge bg-primary">4</span>
                    </div>
                </button>
                <div class="dropdown-menu">
                    <div class="dropdown-header d-flex justify-content-between align-items-center">
                        <span class="title d-inline-block">4 Novas Mensagens</span>
                        <span class="clear-all-btn d-inline-block">Limpar tudo</span>
                    </div>
                    <div class="dropdown-body">
                        <a href="#" class="dropdown-item d-flex align-items-center">
                            <div class="figure">
                                <img src="assets/img/user1.jpg" class="rounded-circle" alt="image">
                            </div>
                            <div class="content d-flex justify-content-between align-items-center">
                                <div class="text">
                                    <span class="d-block">Sarah Taylor</span>
                                    <p class="sub-text mb-0">UX/UI design</p>
                                </div>
                                <p class="time-text mb-0">2 sec ago</p>
                            </div>
                        </a>
                        <a href="#" class="dropdown-item d-flex align-items-center">
                            <div class="figure">
                                <img src="assets/img/user2.jpg" class="rounded-circle" alt="image">
                            </div>
                            <div class="content d-flex justify-content-between align-items-center">
                                <div class="text">
                                <span class="d-block">Lucy Eva</span>
                                    <p class="sub-text mb-0">Web developers</p>
                                </div>
                                <p class="time-text mb-0">5 sec ago</p>
                            </div>
                        </a>
                        <a href="#" class="dropdown-item d-flex align-items-center">
                            <div class="figure">
                                <img src="assets/img/user3.jpg" class="rounded-circle" alt="image">
                            </div>
                            <div class="content d-flex justify-content-between align-items-center">
                                <div class="text">
                                <span class="d-block">James Anderson</span>
                                    <p class="sub-text mb-0">Content whitter</p>
                                </div>
                                <p class="time-text mb-0">3 min ago</p>
                            </div>
                        </a>
                        <a href="#" class="dropdown-item d-flex align-items-center">
                            <div class="figure">
                                <img src="assets/img/user4.jpg" class="rounded-circle" alt="image">
                            </div>
                            <div class="content d-flex justify-content-between align-items-center">
                                <div class="text">
                                <span class="d-block">Steven Smith</span>
                                    <p class="sub-text mb-0">Digital marketing</p>
                                </div>
                                <p class="time-text mb-0">7 min ago</p>
                            </div>
                        </a>
                    </div>
                    <div class="dropdown-footer">
                        <a href="#" class="dropdown-item">View All</a>
                    </div>
                </div>
            </li>-->
            <!-- Notificações gravadas (por enquanto, os avisos de chamado): o número é o de não lidas,
                 do servidor; a lista é buscada ao abrir o menu. -->
            <li class="nav-item notification-box dropdown">
                <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"
                        title="Notificações" aria-label="Notificações" (show.bs.dropdown)="carregarNotificacoes()">
                    <div class="notification-btn">
                        <i class='bx bx-bell'></i>
                        <span *ngIf="totalNotificacoes > 0" class="badge bg-danger">{{ totalNotificacoes > 99 ? '99+' : totalNotificacoes }}</span>
                    </div>
                </button>
                <div class="dropdown-menu">
                    <div class="dropdown-header d-flex justify-content-between align-items-center">
                        <span class="title d-inline-block"><i class='bx bx-bell'></i>{{ totalNotificacoes === 1 ? '1 não lida' : totalNotificacoes + ' não lidas' }}</span>
                        <span *ngIf="totalNotificacoes > 0" (click)="limpar()" class="mark-all-btn d-inline-block" style="cursor: pointer;">Limpar</span>
                    </div>
                    <div class="dropdown-body" *ngIf="notificacoes.length > 0; else emptyState">
                        <a href="javascript:void(0)" class="dropdown-item d-flex align-items-center"
                           [class.notificacao-nao-lida]="!notificacao.lida"
                           *ngFor="let notificacao of notificacoes; trackBy: trackByNotificacao"
                           (click)="abrirNotificacao(notificacao)">
                            <div class="icon">
                                <i class='bx' [ngClass]="notificacao.tipo === 'chamado' ? 'bx-support' : 'bx-bell'"></i>
                            </div>
                            <div class="content">
                                <span class="d-block" [class.fw-bold]="!notificacao.lida">{{ notificacao.titulo }}</span>
                                <small class="text-muted">{{ notificacao.mensagem }}</small>
                                <div class="text-muted mt-1">
                                    <small>{{ notificacao.dataCriacao | date:'dd/MM/yyyy HH:mm' }}</small>
                                </div>
                            </div>
                        </a>
                    </div>

                    <!-- Estado vazio -->
                    <ng-template #emptyState>
                        <div class="dropdown-body notificacoes-vazio text-center py-4">
                            <span class="notificacoes-vazio-icone">
                                <i class='bx' [ngClass]="carregandoNotificacoes ? 'bx-loader-alt bx-spin' : 'bx-bell-off'"></i>
                            </span>
                            <p class="text-muted mb-0 mt-2">{{ carregandoNotificacoes ? 'Carregando...' : 'Nenhuma notificação' }}</p>
                        </div>
                    </ng-template>
                </div>
            </li>

            <!-- Pendências: o número é o que tem novidade não vista (vem do servidor) e só cai quando
                 a pessoa abre a pendência. A lista é buscada ao abrir o menu. -->
            <li class="nav-item notification-box pendencias-box dropdown">
                <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"
                        title="Pendências" aria-label="Pendências" (show.bs.dropdown)="carregarNovidadesPendencias()">
                    <div class="notification-btn">
                        <i class='bx bx-task'></i>
                        <span *ngIf="totalPendencias > 0" class="badge bg-danger">{{ totalPendencias > 99 ? '99+' : totalPendencias }}</span>
                    </div>
                </button>
                <div class="dropdown-menu">
                    <div class="dropdown-header d-flex justify-content-between align-items-center">
                        <span class="title d-inline-block">
                            <i class='bx bx-task'></i>Pendências
                            <span class="selo-total" *ngIf="totalPendencias > 0"
                                  [title]="totalPendencias === 1 ? '1 pendência com atualização não vista' : totalPendencias + ' pendências com atualização não vista'">
                                {{ totalPendencias === 1 ? '1 nova' : totalPendencias + ' novas' }}
                            </span>
                        </span>
                        <span (click)="verTodasPendencias()" class="mark-all-btn d-inline-block" style="cursor: pointer;">Ver todas</span>
                    </div>
                    <div class="dropdown-body" *ngIf="novidadesPendencias.length > 0; else pendenciasVazio">
                        <a href="javascript:void(0)" class="dropdown-item d-flex align-items-center"
                           *ngFor="let item of novidadesPendencias; trackBy: trackByNovidadePendencia"
                           (click)="abrirPendencia(item)">
                            <div class="icon" [class.icon-vencida]="item.pendencia.vencida">
                                <i class='bx bx-task'></i>
                            </div>
                            <div class="content">
                                <span class="d-block fw-bold">{{ item.pendencia.titulo }}</span>
                                <small class="text-muted">{{ item.frase }}</small>
                                <div class="text-muted mt-1">
                                    <small>Criada em: {{ item.pendencia.dataCriacao | date:'dd/MM/yyyy HH:mm' }}</small>
                                </div>
                                <div class="prazo-pendencia" *ngIf="item.pendencia.dataPrazo">
                                    <small>Prazo: {{ item.pendencia.dataPrazo | date:'dd/MM/yyyy HH:mm' }}</small>
                                    <span *ngIf="item.pendencia.vencida" class="selo-vencida ms-2">Vencida</span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <ng-template #pendenciasVazio>
                        <div class="dropdown-body notificacoes-vazio text-center py-4">
                            <span class="notificacoes-vazio-icone">
                                <i class='bx' [ngClass]="carregandoNovidadesPendencias ? 'bx-loader-alt bx-spin' : 'bx-check-double'"></i>
                            </span>
                            <p class="text-muted mb-0 mt-2">{{ carregandoNovidadesPendencias ? 'Carregando...' : 'Nenhuma novidade' }}</p>
                        </div>
                    </ng-template>
                </div>
            </li>

            <li class="nav-item header-divisor d-none d-md-block" aria-hidden="true"></li>

            <li class="nav-item dropdown profile-nav-item">
                <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"
                        title="Perfil" aria-label="Menu do perfil">
                    <div class="menu-profile">
                        <img [src]="urlImagem + usuarioLogado?.imagemPerfil + '.jpg'" class="rounded-circle" alt="image" (error)="$event.target.src='assets/img/no_image.jpg'">
                        <span class="menu-profile-texto d-none d-md-flex">
                            <span class="saudacao">Olá! {{ saudacao }}</span>
                            <span class="name">{{ usuarioLogado?.nome }}</span>
                        </span>
                        <i class='bx bx-chevron-down d-none d-md-inline-block'></i>
                    </div>
                </button>
                <div class="dropdown-menu">
                    <div class="dropdown-header d-flex flex-column align-items-center">
                        <div class="figure mb-3">
                            <img [src]="urlImagem + usuarioLogado?.imagemPerfil + '.jpg'" class="rounded-circle" alt="image" (error)="$event.target.src='assets/img/no_image.jpg'">
                        </div>
                        <div class="info text-center">
                            <span class="name">{{ usuarioLogado?.nome }}</span>
                            <span class="email" *ngIf="usuarioLogado?.email">{{ usuarioLogado.email }}</span>
                        </div>
                    </div>
                    <div class="dropdown-body">
                        <ul class="profile-nav p-0 pt-3">
                            <li class="nav-item">
                                <a href="/usuario/perfil" class="nav-link">
                                    <i class='bx bx-user'></i> <span>Perfil</span>
                                </a>
                            </li>
                            <!--
                                <li class="nav-item">
                                    <a href="#" class="nav-link">
                                        <i class='bx bx-envelope'></i> <span>Caixa de Entrada</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#" class="nav-link">
                                        <i class='bx bx-edit-alt'></i> <span>Editar Perfil</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#" class="nav-link">
                                        <i class='bx bx-cog'></i> <span>Configurações</span>
                                    </a>
                                </li>
                            -->
                        </ul>
                    </div>
                    <div class="dropdown-footer">
                        <ul class="profile-nav">
                            <li class="nav-item">
                                <a (click)="logout()" href="javascript:void(0)" class="nav-link">
                                    <i class='bx bx-log-out'></i> <span>Sair</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</nav>